import { useDebouncedCallback } from "@mantine/hooks"
import { useState, useEffect } from "react"

export function useDebounceWithCallback<T>(
  initialValue: T,
  onChange: (value: T) => void,
  delay = 1000
) {
  const [value, setValue] = useState<T>(initialValue)

  const debouncedOnChange = useDebouncedCallback((value: T) => {
    onChange(value)
  }, delay)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleChange = (newValue: T) => {
    setValue(newValue)
    debouncedOnChange(newValue)
  }

  return [value, handleChange] as const
}
